<template>
    <div>
        <el-alert
            v-if="unregistered_incoming_numbers_count > 0 && !isBrandedCallerIdBundleSelected"
            type="error"
            title="Unregistered Numbers"
            :closable="false"
        >
            <p>{{ unregistered_incoming_numbers_count }} unregistered incoming number(s).</p>
        </el-alert>

        <el-alert
            v-if="unregistered_incoming_numbers_count > 0 && isBrandedCallerIdBundleSelected"
            type="info"
            title="Eligible Numbers"
            :closable="false"
            class="eligible-numbers-alert"
        >
            <p>{{ unregistered_incoming_numbers_count }} eligible incoming number(s) for Branded Caller ID registration.</p>
        </el-alert>

        <hr v-if="unregistered_incoming_numbers_count > 0">

        <!-- Customer Profile Bundle Table -->
        <CustomerProfileBundleTable
            v-if="isCustomerProfileBundleSelected"
            :bundles="bundles"
            :loading-bundles="loadingBundles"
            :company="company"
            :loading-update-bundle="loadingUpdateBundle"
            :loading-delete-bundle="loadingDeleteBundle"
            :unregistered_incoming_numbers_count="unregistered_incoming_numbers_count"
            @use-bundle="handleUseBundle"
            @register-incoming-numbers="handleRegisterIncomingNumbers"
            @delete-bundle="handleDeleteBundle"
        />

        <!-- A2P Trust Bundle Table -->
        <A2pTrustBundleTable
            v-else-if="isA2pTrustBundleSelected"
            :bundles="bundles"
            :loading-bundles="loadingBundles"
            :company="company"
            :loading-update-bundle="loadingUpdateBundle"
            :loading-delete-bundle="loadingDeleteBundle"
            @use-bundle="handleUseBundle"
            @view-details="handleViewDetails"
            @delete-bundle="handleDeleteBundle"
        />

        <!-- A2P Brand Bundle Table -->
        <A2pBrandBundleTable
            v-else-if="isA2pBrandBundleSelected"
            :bundles="bundles"
            :loading-bundles="loadingBundles"
            :loading-update-bundle="loadingUpdateBundle"
            :loading-delete-bundle="loadingDeleteBundle"
            @use-bundle="handleUseBundle"
            @delete-bundle="handleDeleteBundle"
        />

        <!-- A2P Campaign Bundle Table -->
        <A2pCampaignBundleTable
            v-else-if="isA2pCampaignBundleSelected"
            :bundles="bundles"
            :loading-bundles="loadingBundles"
            :company="company"
            :loading-update-bundle="loadingUpdateBundle"
            :loading-delete-bundle="loadingDeleteBundle"
            @view-details="handleViewDetails"
            @delete-bundle="handleDeleteBundle"
        />

        <!-- STIR/SHAKEN Bundle Table -->
        <StirShakenBundleTable
            v-else-if="isStirShakenBundleSelected"
            :bundles="bundles"
            :loading-bundles="loadingBundles"
            :company="company"
            :loading-update-bundle="loadingUpdateBundle"
            :loading-delete-bundle="loadingDeleteBundle"
            :unregistered_incoming_numbers_count="unregistered_incoming_numbers_count"
            @use-bundle="handleUseBundle"
            @register-incoming-numbers="handleRegisterIncomingNumbers"
            @delete-bundle="handleDeleteBundle"
        />

        <!-- Voice Integrity Bundle Table -->
        <VoiceIntegrityBundleTable
            v-else-if="isVoiceIntegrityBundleSelected"
            :bundles="bundles"
            :loading-bundles="loadingBundles"
            :company="company"
            :loading-update-bundle="loadingUpdateBundle"
            :loading-delete-bundle="loadingDeleteBundle"
            :unregistered_incoming_numbers_count="unregistered_incoming_numbers_count"
            @use-bundle="handleUseBundle"
            @register-incoming-numbers="handleRegisterIncomingNumbers"
            @view-details="handleViewDetails"
            @delete-bundle="handleDeleteBundle"
        />

        <!-- CNAM Caller ID Bundle Table -->
        <CnamCallerIdBundleTable
            v-else-if="isCnamBundleSelected"
            :bundles="bundles"
            :loading-bundles="loadingBundles"
            :company="company"
            :loading-update-bundle="loadingUpdateBundle"
            :loading-delete-bundle="loadingDeleteBundle"
            @delete-bundle="handleDeleteBundle"
        />

        <!-- Branded Caller ID Bundle Table -->
        <BrandedCallerIdBundleTable
            v-else-if="isBrandedCallerIdBundleSelected"
            :bundles="bundles"
            :loading-bundles="loadingBundles"
            :company="company"
            :loading-update-bundle="loadingUpdateBundle"
            :loading-delete-bundle="loadingDeleteBundle"
            @register-incoming-numbers="handleRegisterIncomingNumbers"
            @view-details="handleViewDetails"
            @delete-bundle="handleDeleteBundle"
        />

        <!-- Toll-Free Verification Bundle Table -->
        <TollFreeVerificationBundleTable
            v-else-if="isTollFreeVerificationBundleSelected"
            :bundles="bundles"
            :loading-bundles="loadingBundles"
            :company="company"
            :loading-update-bundle="loadingUpdateBundle"
            :loading-delete-bundle="loadingDeleteBundle"
            @view-details="handleViewDetails"
            @delete-bundle="handleDeleteBundle"
        />

        <!-- Address Bundle Table -->
        <AddressBundleTable
            v-else-if="isAddressBundleSelected"
            :bundles="bundles"
            :loading-bundles="loadingBundles"
            :company="company"
            :loading-update-bundle="loadingUpdateBundle"
            :loading-delete-bundle="loadingDeleteBundle"
            @delete-bundle="handleDeleteBundle"
        />

        <!-- Regulatory Bundle Table -->
        <RegulatoryBundleTable
            v-else-if="isRegulatoryBundleSelected"
            :bundles="bundles"
            :loading-bundles="loadingBundles"
            :company="company"
            :loading-update-bundle="loadingUpdateBundle"
            :loading-delete-bundle="loadingDeleteBundle"
            @delete-bundle="handleDeleteBundle"
        />

        <!-- Incoming Number Table -->
        <IncomingNumberTable
            v-else-if="isIncomingNumberSelected"
            :bundles="bundles"
            :loading-bundles="loadingBundles"
            :company="company"
            :loading-update-bundle="loadingUpdateBundle"
            :loading-delete-bundle="loadingDeleteBundle"
        />

        <!-- Verified Caller ID Table -->
        <VerifiedCallerIdBundleTable
            v-else-if="isVerifiedCallerIdSelected"
            :bundles="bundles"
            :loading-bundles="loadingBundles"
            :company="company"
            :loading-update-bundle="loadingUpdateBundle"
            :loading-delete-bundle="loadingDeleteBundle"
            @delete-bundle="handleDeleteBundle"
        />

        <!-- RCS Bundle Table -->
        <RcsBundleTable
            v-else-if="isRcsBundleSelected"
            :bundles="bundles"
            :loading-bundles="loadingBundles"
            :company="company"
            :loading-delete-bundle="loadingDeleteBundle"
            @delete-bundle="handleDeleteBundle"
            @manage-lines="handleManageRcsLines"
        />

        <!-- RCS Manage Lines Dialog -->
        <RcsManageLinesDialog
            :visible="rcsManageLinesDialogVisible"
            :rcs-sender="selectedRcsSender"
            :company="company"
            @close="handleCloseRcsManageLinesDialog"
            @assigned="handleRcsLinesAssigned"
        />

        <!-- Unregistered Numbers Dialog -->
        <UnregisteredNumbersDialog
            :visible="assignNumbersDialogVisible"
            :bundle="selectedBundle"
            :bundle-type="type"
            :company="company"
            @close="handleCloseAssignNumbersDialog"
            @assigned="handleNumbersAssigned"
        />
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { compliance_mixin } from '../../mixins'
import * as ComplianceBundleTypes from '../../constants/compliance-bundle-types'
import CustomerProfileBundleTable from './tables/customer-profile-bundle-table'
import A2pTrustBundleTable from './tables/a2p-trust-bundle-table'
import A2pBrandBundleTable from './tables/a2p-brand-bundle-table'
import A2pCampaignBundleTable from './tables/a2p-campaign-bundle-table'
import StirShakenBundleTable from './tables/stir-shaken-bundle-table'
import VoiceIntegrityBundleTable from './tables/voice-integrity-bundle-table'
import CnamCallerIdBundleTable from './tables/cnam-caller-id-bundle-table'
import BrandedCallerIdBundleTable from './tables/branded-caller-id-bundle-table'
import TollFreeVerificationBundleTable from './tables/toll-free-verification-bundle-table'
import AddressBundleTable from './tables/address-bundle-table'
import RegulatoryBundleTable from './tables/regulatory-bundle-table'
import IncomingNumberTable from './tables/incoming-number-table'
import VerifiedCallerIdBundleTable from './tables/verified-caller-id-bundle-table'
import RcsBundleTable from './tables/rcs-bundle-table'
import RcsManageLinesDialog from './rcs-manage-lines-dialog'
import UnregisteredNumbersDialog from './unregistered-numbers-dialog'

export default {
    name: 'ComplianceBundleList',
    components: {
        CustomerProfileBundleTable,
        A2pTrustBundleTable,
        A2pBrandBundleTable,
        A2pCampaignBundleTable,
        StirShakenBundleTable,
        VoiceIntegrityBundleTable,
        CnamCallerIdBundleTable,
        BrandedCallerIdBundleTable,
        TollFreeVerificationBundleTable,
        AddressBundleTable,
        RegulatoryBundleTable,
        IncomingNumberTable,
        VerifiedCallerIdBundleTable,
        RcsBundleTable,
        RcsManageLinesDialog,
        UnregisteredNumbersDialog,
    },
    mixins: [compliance_mixin],
    data() {
        return {
            assignNumbersDialogVisible: false,
            selectedBundle: null,
            rcsManageLinesDialogVisible: false,
            selectedRcsSender: null,
        }
    },
    props: {
        loadingBundles: {
            type: Boolean,
            required: true,
        },
        company: {
            type: Object,
            required: true,
        },
        type: {
            type: Number,
            required: true,
        },
        bundles: {
            type: Array,
            deep: true,
            required: true,
            default: () => [],
        },
        unregistered_incoming_numbers_count: {
            type: Number,
            required: true,
            default: 0,
        },
    },
    computed: {
        ...mapState([
            'loading_update_bundle',
            'loading_delete_bundle'
        ]),
        loadingUpdateBundle() {
            return this.loading_update_bundle || []
        },
        loadingDeleteBundle() {
            return this.loading_delete_bundle || []
        },
        isCustomerProfileBundleSelected() {
            return this.type === ComplianceBundleTypes.CUSTOMER_PROFILE
        },
        isA2pTrustBundleSelected() {
            return this.type === ComplianceBundleTypes.A2P_TRUST_PRODUCT
        },
        isA2pBrandBundleSelected() {
            return this.type === ComplianceBundleTypes.A2P_BRAND
        },
        isA2pCampaignBundleSelected() {
            return this.type === ComplianceBundleTypes.A2P_MESSAGING_SERVICE
        },
        isStirShakenBundleSelected() {
            return this.type === ComplianceBundleTypes.STIR_SHAKEN
        },
        isVoiceIntegrityBundleSelected() {
            return this.type === ComplianceBundleTypes.VOICE_INTEGRITY
        },
        isCnamBundleSelected() {
            return this.type === ComplianceBundleTypes.CNAM_BUNDLE
        },
        isTollFreeVerificationBundleSelected() {
            return this.type === ComplianceBundleTypes.TOLL_FREE_VERIFICATION
        },
        isAddressBundleSelected() {
            return this.type === ComplianceBundleTypes.ADDRESS_BUNDLE
        },
        isRegulatoryBundleSelected() {
            return this.type === ComplianceBundleTypes.REGULATORY_BUNDLE
        },
        isIncomingNumberSelected() {
            return this.type === ComplianceBundleTypes.INCOMING_NUMBER
        },
        isVerifiedCallerIdSelected() {
            return this.type === ComplianceBundleTypes.VERIFIED_CALLER_ID
        },
        isBrandedCallerIdBundleSelected() {
            return this.type === ComplianceBundleTypes.BRANDED_CALLER_ID
        },
        isRcsBundleSelected() {
            return this.type === ComplianceBundleTypes.RCS
        },
    },
    methods: {
        handleUseBundle(bundle) {
            this.changeActiveBundle(bundle, bundle.type)
        },
        handleRegisterIncomingNumbers(bundle) {
            this.selectedBundle = bundle
            this.assignNumbersDialogVisible = true
        },
        handleCloseAssignNumbersDialog() {
            this.assignNumbersDialogVisible = false
            this.selectedBundle = null
        },
        handleNumbersAssigned() {
            this.$emit('numbers-assigned')
        },
        handleViewDetails(bundle) {
            // For A2P Trust Bundle, this would open brand review dialog
            this.$emit('view-details', bundle)
        },
        handleDeleteBundle(bundle) {
            this.deleteBundleRemote(bundle)
        },
        handleManageRcsLines(bundle) {
            this.selectedRcsSender = bundle
            this.rcsManageLinesDialogVisible = true
        },
        handleCloseRcsManageLinesDialog() {
            this.rcsManageLinesDialogVisible = false
            this.selectedRcsSender = null
        },
        handleRcsLinesAssigned() {
            this.$emit('numbers-assigned')
        },
        changeActiveBundle(target_bundle) {
            this.pushLoadingUpdateBundleId(target_bundle.id)
            axios
                .post(`/api/admin/compliance/${this.company.id}/${this.type}/${target_bundle.id}/use`)
                .then(() => {
                    this.$notify({
                        title: 'Enable bundle',
                        message: 'Operation is being processed...',
                        type: 'success',
                        showClose: true,
                    })
                })
                .catch((err) => {
                    this.$root.handleErrors(err)
                    this.pullIdFromLoadingUpdateBundle(target_bundle.id)
                })
        },
        deleteBundleRemote(target_bundle) {
            let message = 'Are you sure you want to delete this bundle?'

            this.$confirm(
                message,
                'Warning',
                {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    customClass: 'width-500 fixed',
                    type: 'warning',
                }
            )
                .then(() => {
                    this.pushIdToLoadingDeleteBundle(target_bundle.id)
                    axios
                        .delete(`/api/admin/compliance/${this.company.id}/${this.type}/${target_bundle.id}`)
                        .then(() => {
                            this.$notify({
                                title: 'Delete bundle',
                                message: 'Operation is being processed...',
                                type: 'success',
                                showClose: true,
                            })
                        })
                        .catch((err) => {
                            this.$root.handleErrors(err)
                            this.pullIdFromLoadingDeleteBundle(target_bundle.id)
                        })
                })
                .catch(() => {
                })
        },
        ...mapActions([
            'pushLoadingUpdateBundleId',
            'pullIdFromLoadingUpdateBundle',
            'pushIdToLoadingDeleteBundle',
            'pullIdFromLoadingDeleteBundle'
        ]),
    },
}
</script>

<style scoped>
.eligible-numbers-alert {
    background-color: #ecf5ff;
    border-color: #b3d8ff;
}

.eligible-numbers-alert >>> .el-alert__title {
    color: #409eff;
}

.eligible-numbers-alert >>> .el-alert__icon {
    color: #409eff;
}

.eligible-numbers-alert >>> p {
    color: #409eff;
}
</style>
